<template>
	<v-container fluid class="pt-4">
	  <v-row justify="center">
	  	<v-col cols="12">
        <v-card class="mx-auto transparent elevation-0">
          <v-card-text class="pb-0">
            <div class="mb-0 font-weight-bold text-h6 text-center">
              Hola, aún no cuentas con un registro, por favor, registra tus datos
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" lg="6">
      	<v-card class="mx-auto shadowCard" >
			    <v-card-title class="text-h6 font-weight-regular justify-space-between">
			      <span>{{ currentTitle }}</span>
			      <v-avatar
			        color="primary lighten-2"
			        class="subheading white--text"
			        size="24"
			        v-text="step"
			      ></v-avatar>
			    </v-card-title>

			    <v-window v-model="step">
			      <v-window-item :value="1">
			        <v-card-text class="mb-4">
			          <v-form
							    ref="form"
							    v-model="valid"
							    lazy-validation
							  >
							  	<v-row>
							  		<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.nombre"
									      :rules="[rules.required]"
									      label="Nombre *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
							  		</v-col>

							  		<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.apellido_paterno"
									      :rules="[rules.required]"
									      label="Apellido paterno *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
										</v-col>

										<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.apellido_materno"
									      label="Apellido materno"
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
										</v-col>

										<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.email"
									      :rules="[rules.required, rules.email]"
									      type="email"
									      label="Correo *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
							  		</v-col>

										<v-col cols="6" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.edad"
									      :rules="[rules.required]"
									      label="Edad *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
										</v-col>

										<v-col cols="6" class="pb-0">
											<v-select
									    	:items="[{id:0,text:'Hombre'}, {id:1,text:'Mujer'}]"
									      v-model="usuario.sexo"
									      label="Sexo *"
									      item-text="text"
									      item-value="id"
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-select>
										</v-col>

										<v-col cols="6" class="pb-0">
											<v-text-field
									      v-model.number="usuario.telefono"
									      :rules="[rules.required]"
									      label="Teléfono *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
										</v-col>

										<v-col cols="6" class="pb-0">
											<v-text-field
									      v-model.number="usuario.celular"
									      :rules="[rules.required]"
									      label="WhatsApp *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
										</v-col>

										<v-col cols="12" class="pb-0">
											<v-text-field
									      v-model.number="usuario.contacto_emergencia"
									      :rules="[rules.required]"
									      label="Contacto emergencia *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
										</v-col>
							  	</v-row>
							  </v-form>
			          <!-- <span class="text-caption grey--text text--darken-1">
			            This is the email you will use to login to your Vuetify account
			          </span> -->
			        </v-card-text>
			      </v-window-item>

			      <v-window-item :value="2">
			        <v-card-text class="mb-4">
			          <v-form
							    ref="formDireccion"
							    v-model="valid2"
							    lazy-validation
							  >
							  	<v-row>
							  		<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.calle"
									      :rules="[rules.required]"
									      label="Calle *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
							  		</v-col>

							  		<v-col cols="6" class="pb-0">
									    <v-text-field
									      v-model.number="usuario.numero"
									      :rules="[rules.required]"
									      label="Número *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
										</v-col>

										<v-col cols="6" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.cp"
									      label="CP"
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
										</v-col>

										<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.colonia"
									      :rules="[rules.required]"
									      label="Colonia *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
							  		</v-col>

										<v-col cols="6" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.municipio"
									      :rules="[rules.required]"
									      label="Municipio *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
										</v-col>

										<v-col cols="6" class="pb-0">
											<v-select
									    	:items="estados"
									      v-model="usuario.estado"
									      :rules="[rules.required]"
									      label="Estado *"
									      item-text="text"
									      item-value="id"
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-select>
										</v-col>
							  	</v-row>
							  </v-form>
			          <!-- <span class="text-caption grey--text text--darken-1">
			            This is the email you will use to login to your Vuetify account
			          </span> -->
			        </v-card-text>
			      </v-window-item>

			      <v-window-item :value="3">
			        <v-card-text class="mb-4">
			          <v-form
							    ref="formEncuesta"
							    v-model="valid3"
							    lazy-validation
							  >
							  	<v-row>
							  		<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'Publicidad', id:1},{text:'Facebook', id:2},{text:'Instagram', id:3},{text:'Internet', id:4}]"
									      v-model="usuario.medio_contacto"
									      :rules="[rules.required]"
									      label="Medio de contacto"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									      item-text="text"
									      item-value="id"
									    ></v-select>
							  		</v-col>

							  		<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'Estudiante', id:1},{text:'Empleado', id:2},{text:'Otro', id:3}]"
									      v-model="usuario.ocupacion"
									      :rules="[rules.required]"
									      label="Ocupación"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									      item-text="text"
									      item-value="id"
									    ></v-select>
										</v-col>

										<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'Soltero', id:1},{text:'Casado', id:2},{text:'Unión libre', id:3},{text:'Otro', id:4}]"
									      v-model="usuario.estado_civil"
									      :rules="[rules.required]"
									      label="Estado civil"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									      item-text="text"
									      item-value="id"
									    ></v-select>
										</v-col>

										<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'0', id:1},{text:'1', id:2},{text:'2', id:3},{text:'3 o más', id:4}]"
									      v-model="usuario.hijos"
									      :rules="[rules.required]"
									      label="Hijos"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									      item-text="text"
									      item-value="id"
									    ></v-select>
										</v-col>

										<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'Hobbie', id:1},{text:'Trabajo', id:2},{text:'Escuela', id:3},{text:'Otro', id:4}]"
									      v-model="usuario.motivo_estudio"
									      :rules="[rules.required]"
									      label="Motivo de estudio"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									      item-text="text"
									      item-value="id"
									    ></v-select>
										</v-col>

										<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'Carro', id:1},{text:'Metro', id:2},{text:'Camión', id:3},{text:'Otro', id:4}]"
									      v-model="usuario.transporte"
									      :rules="[rules.required]"
									      label="Transporte"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									      item-text="text"
									      item-value="id"
									    ></v-select>
										</v-col>

										<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model="usuario.facebook"
									      label="Facebook *"
									      required
									      rounded
									      filled
									      color="primary"
									      hide-details
									    ></v-text-field>
										</v-col>
							  	</v-row>
							  </v-form>
			          <!-- <span class="text-caption grey--text text--darken-1">
			            This is the email you will use to login to your Vuetify account
			          </span> -->
			        </v-card-text>
			      </v-window-item>

			      <v-window-item :value="4">
			        <div class="pa-4 text-center">
			          <v-img
			            class="mb-4"
			            contain
			            height="128"
			            src="@/assets/alertas/send.png"
			          ></v-img>

			          <div style="min-height: 4px;">
							    <v-progress-linear
							      v-model="value"
							      :active="show"
							      :indeterminate="query"
							      :query="true"
							    ></v-progress-linear>
							  </div>

			          <h3 class="text-h6 font-weight-light mb-2" v-if="correoEnviado">
			            Correo enviado con exito
			            <br/>
			            Activa tu cuenta desde el correo que se te ha enviado
			          </h3>
			          <span class="text-caption grey--text">Gracias por registrarte</span>
			        </div>
			      </v-window-item>
			    </v-window>

			    <v-divider v-if="step < 4"></v-divider>

			    <v-card-actions>
			      <v-btn
			      	v-if="step <= 3"
			        :disabled="step === 1"
			        text
			        @click="step--"
			        rounded
			        class="text-capitalize"
			      >
			        Regresar
			      </v-btn>
			      <v-spacer></v-spacer>

			      <v-btn
			        v-if="step < 3"
			        color="primary"
			        depressed
			        @click="step++"
			        rounded
			        class="text-capitalize"
			      >
			        Siguiente
			      </v-btn>

			      <v-btn
			        v-else-if="step == 3"
			        color="primary"
			        depressed
			        rounded
			        class="text-capitalize"
			        @click="registrarDatos()"
			      >
			        Registrar
			      </v-btn>
			    </v-card-actions>
			  </v-card>
      </v-col>
	  </v-row>

		<Alerta   v-if="respuestaAlerta" :parametros="parametros"/>
		<Loader   v-if="cargar"          :loader="loader"/>

	</v-container>	
</template>
<script>
	import { mapActions, mapGetters } from 'vuex'
	// Dependencias
  const md5     = require('md5')

  // Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  // Mixins
  import  validarErrores from '@/mixins/validarErrores.js';

  export default {
  	components:{
  		Alerta,
  		Loader
  	},

  	mixins:[validarErrores],

    data: () => ({
    	loader: true,
      cargar: false,

    	step: 1,
      ventana: 1,
      perfil: null,
      valid: true,
      valid2: true,
      valid3: true,

      usuario: {
				nombre:'',			
				apellido_paterno:'',			
				apellido_materno:'',
				edad:'',			
				email:'',			
				sexo:'',	
				contacto_emergencia:'',		
				telefono:'',			
				celular:'',

				// Direccion
				calle:'',
	    	numero:'',
	    	cp:'',
	    	colonia:'',
	    	municipio:'',
	    	estado:'',

	    	// Marketing
	    	medio_contacto:'',
		    ocupacion:'',
		    estado_civil:'',
		    hijos:'',
		    motivo_estudio:'',
		    transporte:'',
		    facebook:'',
		    activo:0,
      },

		  correoEnviado: true,

			rules: {
        required: value => !!value || 'Requerido.',
        email: value=> /.+@.+\..+/.test(value) || 'E-mail must be valid'
      },

      estados:[
				{id: 1, text:'Aguascalientes'},
				{id: 2, text:'Baja California'},
				{id: 3, text:'Baja California Sur'},
				{id: 4, text:'Campeche'},
				{id: 5, text:'Coahuila'},
				{id: 6, text:'Colima'},
				{id: 7, text:'Chiapas'},
				{id: 8, text:'Chihuahua'},
				{id: 9, text:'Distrito Federal'},
				{id: 10, text:'Durango'},
				{id: 11, text:'Guanajuato'},
				{id: 12, text:'Guerrero'},
				{id: 13, text:'Hidalgo'},
				{id: 14, text:'Jalisco'},
				{id: 15, text:'México'},
				{id: 16, text:'Michoacán'},
				{id: 17, text:'Morelos'},
				{id: 18, text:'Nayarit'},
				{id: 19, text:'Nuevo León'},
				{id: 20, text:'Oaxaca'},
				{id: 21, text:'Puebla'},
				{id: 22, text:'Querétaro'},
				{id: 23, text:'Quintana Roo'},
				{id: 24, text:'San Luis Potosí'},
				{id: 25, text:'Sinaloa'},
				{id: 26, text:'Sonora'},
				{id: 27, text:'Tabasco'},
				{id: 28, text:'Tamaulipas'},
				{id: 29, text:'Tlaxcala'},
				{id: 30, text:'Veracruz'},
				{id: 31, text:'Yucatán'},
				{id: 32, text:'Zacatecas'},
      ],

      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

     	respuestaAlerta:false,

     	value: 0,
      query: false,
      show: true,
      interval: 0,

    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS']),

    	currentTitle () {
        switch (this.step) {
          case 1: return 'Datos personales'
          case 2: return 'Dirección'
          case 3: return 'Datos adicionales'
          default: return 'Registart cuenta'
        }
      },

    },

    created(){
    	console.log( this.getUsuarioLMS )
    	this.usuario.nombre = this.getUsuarioLMS.nombre
			this.usuario.apellido_paterno = this.getUsuarioLMS.apellido_paterno
			this.usuario.apellido_materno = this.getUsuarioLMS.apellido_materno
			this.usuario.email = this.getUsuarioLMS.email
			this.usuario.telefono = this.getUsuarioLMS.telefono
			this.usuario.celular = this.getUsuarioLMS.telefono
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario', 'salirLogin' ]),


      validarDatos () {
        return this.$refs.form.validate() && this.$refs.formDireccion.validate() && this.$refs.formEncuesta.validate()
      },

      registrarDatos (){
      	if( this.validarDatos() ){
      		this.cargar = true
      		this.usuario['id_usuario'] = this.getUsuarioLMS.id
	      	this.$http.post('usuario.enviar.correo', this.usuario).then( response => {
	      		this.step++
	      		this.cargar = false
	      		this.iniciarContador()
	      	}).catch( error => {
	      		this.cargar = false
	      		if( error.status == 400 || error.status == 500 ){
	      			this.parametros.mensaje      = error.body.message
	      			this.parametros.dialogError  = true 
	      			this.parametros.color        = '#FF2C2C'
	      			this.respuestaAlerta         = true 
	      		}
	      	})
      	}else{
      		this.parametros.mensaje = 'Por favor, revisa que todos tus datos estén correctos'
    			this.parametros.dialogError  = true 
    			this.parametros.color        = '#FF2C2C'
    			this.respuestaAlerta = true 
      	}
      },

      iniciarContador ( ){
      	this.query = true
        this.show = true
        this.value = 0

        setTimeout(() => {
          this.query = false

          this.interval = setInterval(() => {
            if (this.value === 100) {
              clearInterval(this.interval)
              this.salirLogin()

              return setTimeout(this.queryAndIndeterminate, 2000)
            }
            this.value += 5
          }, 1000)
        }, 500)
      } 
    },
  }
</script>
<style>
	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}

</style>